export default __webpack_public_path__ + "static/media/slider-2.768dc6a8.jpg";